$('.confirm-button').on('click', function (e) {
    e.preventDefault();

    let link = $(this).attr('href');
    let confirmationModal = $('#confirmation-button-modal');

    confirmationModal.find('.confirm-button-route').attr('href', link);
    confirmationModal.modal('show');
});
